module.exports = __webpack_public_path__ + "static/media/IconPesq.52153688.svg";